export default __webpack_public_path__ + "static/media/location-sm.330fcc70.png";